import { Box, SxProps, useTheme } from '@mui/material';
import { flexCenter } from '../commonUI/cssClasses';
import OnboardingHeader from './OnboardingHeader';
import { OnboardProvider } from './context/OnboardContext';
import OnboardForms from './forms/OnboardForms';
import BlockBoundaryOnboardDialog from './forms/blockBoundaryMapForm/BlockBoundaryOnboardDialog';
import OnboardList from './onboardList/OnboardList';

export const OnboardingPage = () => {
  const theme = useTheme();

  const commonStyles: SxProps = {
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    height: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    ...flexCenter,
    bgcolor: theme.colors.darkTheme.grey.light,
    borderRadius: theme.borderRadius.primary,
  };

  return (
    <OnboardProvider>
      <BlockBoundaryOnboardDialog />
      <Box
        sx={{
          width: '100%',
          minWidth: '100%',
          maxWidth: '100%',
          height: '100vh',
          maxHeight: '100vh',
          bgcolor: theme.colors.darkTheme.grey.dark,
          display: 'grid',
          gridTemplateColumns: '1fr',
          gridTemplateRows: 'min-content 1fr',
          gridTemplateAreas: `
        'headerArea'
        'contentAArea'
        `,
        }}
      >
        <Box sx={{ gridArea: 'headerArea', ...flexCenter }}>
          <OnboardingHeader />
        </Box>
        <Box
          sx={{
            gridArea: 'contentAArea',
            width: '100%',
            minWidth: '100%',
            maxWidth: '100%',
            height: '100%',
            minHeight: '100%',
            maxHeight: '100%',
            ...flexCenter,
            bgcolor: theme.colors.darkTheme.grey.dark,
          }}
        >
          <Box
            sx={{
              width: '100%',
              minWidth: '100%',
              maxWidth: '100%',
              height: '100%',
              minHeight: '100%',
              maxHeight: '100%',
              bgcolor: theme.colors.darkTheme.grey.dark,
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gridTemplateRows: '1fr',
              gridGap: theme.recentScansPage.spacing,
              p: theme.recentScansPage.spacing,
              gridTemplateAreas: `
    'formArea listArea'    
    `,
            }}
          >
            <Box
              sx={{
                gridArea: 'formArea',
                overflowY: 'hidden',
                ...commonStyles,
              }}
            >
              <OnboardForms />
            </Box>
            <Box
              sx={{
                gridArea: 'listArea',
                overflowY: 'hidden',
                ...commonStyles,
              }}
            >
              <OnboardList />
            </Box>
          </Box>
        </Box>
      </Box>
    </OnboardProvider>
  );
};
